import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { Button, Modal, Pagination, Form, DropdownButton, Dropdown } from 'react-bootstrap';
import Confirm from '../../../components/Modal/Confirm';

import Loading from '../../../components/Loading/Loading';
import pagination from '../../../utils/pagination';
import { getStatus, promoteJobs, createJobs, cleanJobs, remapJobs, cleanMeta, cleanUp, retryJobs, removeJobs, cleanWebhook } from '../StatusActions';
import CheckBox from '../../../components/CheckBox/CheckBox';
import EllipsisWithTooltip from '../../../components/EllipsisWithTooltip';

import resyncIcon from '../../../assets/images/sync.svg';
import openInNewIcon from '../../../assets/images/open-in-new.svg';
import failedIcon from '../../../assets/images/failed-icon.svg';
import delayIcon from '../../../assets/images/delay-icon.svg';
import Close from '../../../assets/images/close.svg';
import arrowRight from '../../../assets/images/arrow_right.svg';

import '../../../assets/styles/_table.scss';
import '../Status.scss';

const OBJECT_ID_PATTERN = /^[a-f0-9]{24}$/i;

class StatusTable extends Component {
  static propTypes = {
    pagination: PropTypes.bool,
    show: PropTypes.number,
  };

  static defaultProps = {
    pagination: true,
    show: 20,
  };

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      dateFormat: 'DD MMM YYYY HH:mm z',
      searchInput: '',
      search: '',
      app: 'jira',
      appOptions: [
        { name: 'Jira', value: 'jira' },
        { name: 'Trello', value: 'trello' },
        { name: 'Asana', value: 'asana' },
        { name: 'Azure', value: 'azure' },
      ],
      subs: 'ALL',
      subsOptions: [
        { name: 'All Subscription', value: 'ALL' },
        { name: 'Active', value: 'ACTIVE' },
        { name: 'Trial', value: 'TRIAL' },
        { name: 'Trial Expired', value: 'EXPIRED' },
        { name: 'Cancelled', value: 'CANCELLED' },
      ],
      status: 'ALL',
      statusOptions: [
        { name: 'All Status', value: 'ALL' },
        { name: 'Healthy', value: 'HEALTHY' },
        { name: 'Sick', value: 'SICK' },
      ],
      action: 'ALL',
      actionOptions: [
        { name: 'All Action', value: 'ALL' },
        { name: 'Clean', value: 'CLEAN' },
        { name: 'Resync', value: 'RESYNC' },
        { name: 'Retry', value: 'RETRY' },
        { name: 'Create Jobs', value: 'CREATE' },
        { name: 'Remap Jobs', value: 'REMAP' },
        { name: 'Clean Webhook', value: 'WEBHOOK' },
      ],
      limit: 100,
      limitOptions: [
        { name: '10', value: 10 },
        { name: '50', value: 50 },
        { name: '100', value: 100 },
        { name: '500', value: 500 },
        { name: '1000', value: 1000 },
      ],
      webhook: 'ALL',
      webhookOptions: [
        { name: 'All Webhook', value: 'ALL' },
        { name: 'No webhook', value: 'FALSE' },
        { name: 'Has webhook', value: 'TRUE' }
      ],
      pullJob: 'ALL',
      pullJobOptions: [
        { name: 'All Pulling', value: 'ALL' },
        { name: 'No pull job', value: 'FALSE' },
        { name: 'Has pull job', value: 'TRUE' }
      ],
      weeklyJob: 'ALL',
      weeklyJobOptions: [
        { name: 'All Weekly', value: 'ALL' },
        { name: 'No weekly job', value: 'FALSE' },
        { name: 'Has weekly job', value: 'TRUE' }
      ],
      auditJob: 'ALL',
      auditJobOptions: [
        { name: 'All Audit', value: 'ALL' },
        { name: 'No audit job', value: 'FALSE' },
        { name: 'Has audit job', value: 'TRUE' }
      ],
      issue: 'ALL',
      issueOptions: [
        { name: 'All Issue', value: 'ALL' },
        { name: 'Weekly not found', value: 'WEEKLY JOB NOT FOUND' },
        { name: 'Weekly not mapped', value: 'WEEKLY JOB NOT MAPPED' },
        { name: 'Weekly meta gone', value: 'WEEKLY META NOT FOUND' },
        { name: 'Weekly is failed', value: 'WEEKLY JOB IS FAILED' },
        { name: 'Weekly is stuck', value: 'WEEKLY JOB IS STUCK' },
        { name: 'Weekly wrong user', value: 'WEEKLY USER IS WRONG' },
        { name: 'Weekly is not required', value: 'WEEKLY JOB NOT REQUIRED' },
        { name: 'Multiple weekly', value: 'MULTIPLE WEEKLY JOBS' },
        { name: 'Pull not found', value: 'PULL JOB NOT FOUND' },
        { name: 'Pull not mapped', value: 'PULL JOB NOT MAPPED' },
        { name: 'Pull is failed', value: 'PULL JOB IS FAILED' },
        { name: 'Pull is stuck', value: 'PULL JOB IS STUCK' },
        { name: 'Pull is not required', value: 'PULL JOB NOT REQUIRED' },
        { name: 'Pull meta gone', value: 'PULL META NOT FOUND' },
        { name: 'Pull wrong user', value: 'PULL USER IS WRONG' },
        { name: 'Multiple pulling', value: 'MULTIPLE PULL JOBS' },
        { name: 'Audit not found', value: 'AUDIT JOB NOT FOUND' },
        { name: 'Audit not mapped', value: 'AUDIT JOB NOT MAPPED' },
        { name: 'Audit is failed', value: 'AUDIT JOB IS FAILED' },
        { name: 'Audit is stuck', value: 'AUDIT JOB IS STUCK' },
        { name: 'Audit is not required', value: 'AUDIT JOB NOT REQUIRED' },
        { name: 'Audit meta gone', value: 'AUDIT META NOT FOUND' },
        { name: 'Audit wrong user', value: 'AUDIT USER IS WRONG' },
        { name: 'Audit issues', value: 'AUDIT JOB DETECTS ISSUE' },
        { name: 'Multiple audit', value: 'MULTIPLE AUDIT JOBS' },
        { name: 'No webhook', value: 'NO WEBHOOK' },
        { name: 'Remove Webhook', value: 'WEBHOOK IS NOT REQUIRED' },
        { name: 'No access', value: 'NO ACCESS' },
        { name: 'No user', value: 'NO USER' },
        { name: 'No board', value: 'NO BOARD' },
      ],
      selected: {},
      toCleanUp: [],
      toCleanMeta: [],
      toCreatePull: [],
      toRemove: [],
      toResync: [],
      moreInfoModal: { show: false, data: null },
    };

    this.getStatusDebounced = _.debounce(this.getStatus, 150);
  }

  componentDidMount() {
    this.getStatus();
  }

  componentWillUnmount() {
    this.getStatusDebounced.cancel();
  }

  handleChange = (ev) => {
    const searchInput = ev.target.value;

    const isObjectId = OBJECT_ID_PATTERN.test(searchInput.trim());
    const search = isObjectId ? searchInput.trim() : '';
    const changed = search !== this.state.search;

    this.setState({ searchInput, search, page: 1 }, () => {
      if (!changed) {
        return;
      }
      if (isObjectId) {
        this.getStatusDebounced.cancel();
        this.getStatus();
      } else {
        this.getStatusDebounced();
      }
    });
  };

  goto = (page = 1) => {
    if (page < 1) {
      page = 1;
    }
    this.setState({ page }, this.getStatus);
  };

  getStatus = () => {
    this.setState({ selected: {} }, () => this.props.getStatus(this.getOpts()));
  };

  getOpts = () => {
    const { search, page, app, subs, limit, webhook, pullJob, weeklyJob, auditJob } = this.state;
    return {
      app,
      subs,
      search,
      webhook,
      pulling: pullJob,
      weekly: weeklyJob,
      audit: auditJob,
      page,
      limit
    };
  }

  retry = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('RETRY', ids);
    this.props.retryJobs(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  promote = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('PROMOTE', ids);
    this.props.promoteJobs(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  create = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('CREATE', ids);
    this.props.createJobs(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  clean = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('CLEAN', ids);
    this.props.cleanJobs(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  cleanMeta = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('CLEAN META', ids);
    this.props.cleanMeta(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  remap = (id, pulling = false, audit = false) => {
    const ids = [id];
    console.log('REMAP', ids);
    this.props.remapJobs(ids, { ...this.getOpts(), type: audit ? 'audit' : pulling ? 'pulling' : 'normal'});
  }

  cleanUp = (data) => {
    const normal = _.filter(data.normal, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `N:${j.id}`);
    const pulling = _.filter(data.pulling, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `P:${j.id}`);
    const audit = _.filter(data.audit, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `A:${j.id}`);
    const ids = _.concat(normal, pulling, audit);
    console.log('CLEAN-UP', ids);
    this.props.cleanUp(ids, { ...this.getOpts() });
  }

  remove = (data) => {
    const normal = _.filter(data.normal, j => this.isMapped(data, j)).map(j => `N:${j.id}`);
    const pulling = _.filter(data.pulling, j => this.isMapped(data, j)).map(j => `P:${j.id}`);
    const audit = _.filter(data.audit, j => this.isMapped(data, j)).map(j => `A:${j.id}`);
    const ids = _.concat(normal, pulling, audit);
    console.log('REMOVE', ids);
    this.props.cleanUp(ids, { ...this.getOpts() });
  }

  cleanWebhook = (id) => {
    const ids = [id];
    console.log('CLEAN WEBHOOK', ids);
    this.props.cleanWebhook(ids, { ...this.getOpts() });
  }

  cleanDashboardsUp = () => {
    const { toCleanUp } = this.state;
    const jobIds = _(toCleanUp).map(data => {
      const normal = _.filter(data.normal, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `N:${j.id}`);
      const pulling = _.filter(data.pulling, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `P:${j.id}`);
      const audit = _.filter(data.pulling, j => !this.isMapped(data, j) && (j.state === 'failed' || j.state === 'completed')).map(j => `A:${j.id}`);
      return _.concat(normal, pulling, audit);
    }).flatten().value();

    console.log('CLEAN-UP JOB IDS', jobIds);
    this.props.cleanUp(jobIds, { ...this.getOpts() });
    this.setState({ toCleanUp: [] });
  }

  cleanDashboardsMeta = () => {
    const { toCleanMeta } = this.state;
    const dashboardIds = _(toCleanMeta).map(data => data.dashboardId).compact().uniq().value();
    console.log('CLEAN-UP JOB META IDS', dashboardIds);
    this.props.cleanMeta(dashboardIds, { ...this.getOpts(), type: 'pulling' });
    this.setState({ toCleanMeta: [] });
  }

  createDashboardsPull = () => {
    const { toCreatePull } = this.state;
    const dashboardIds = _(toCreatePull).map(data => data.dashboardId).compact().uniq().value();
    console.log('CREATE PULL JOBS', dashboardIds);
    this.props.createJobs(dashboardIds, { ...this.getOpts(), type: 'pulling' });
    this.setState({ toCreatePull: [] });
  }

  removeDashboardsJobs = () => {
    const { toRemove } = this.state;
    const jobIds = _(toRemove).map(data => {
      if (data.subscription === 'trial expired' || data.subscription === 'cancelled') {
        const normal = _.filter(data.normal, j => this.isMapped(data, j));
        const pulling = _.filter(data.pulling, j => this.isMapped(data, j));
        return _.concat(normal, pulling).map(j => j.id);
      } else {
        return [];
      }
    }).flatten().value();

    console.log('REMOVE JOBS', jobIds);
    this.props.removeJobs(jobIds, { ...this.getOpts() });
    this.setState({ toRemove: [] });
  }

  renderSelected = (type) => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type],
    });
    return selected ? selected.name : '';
  };

  applyAppFilter = (app) => {
    this.setState({ app, page: 1 }, this.getStatus);
  }

  applySubsFilter = (subs) => {
    this.setState({ subs }, this.getStatus);
  }

  applyWebhookFilter = (webhook) => {
    this.setState({ webhook }, this.getStatus);
  }

  applyPullFilter = (pullJob) => {
    this.setState({ pullJob }, this.getStatus);
  }

  applyAuditFilter = (auditJob) => {
    this.setState({ auditJob }, this.getStatus);
  }

  applyWeeklyFilter = (weeklyJob) => {
    this.setState({ weeklyJob }, this.getStatus);
  }

  applyStatusFilter = (status) => {
    this.setState({ status }, () => this.selectAllDashboards({ checked: false }));
  }

  applyActionFilter= (action) => {
    this.setState({ action }, () => this.selectAllDashboards({ checked: false }));
  }

  applyIssueFilter= (issue) => {
    this.setState({ issue }, () => this.selectAllDashboards({ checked: false }));
  }

  applyLimitFilter= (limit) => {
    this.setState({ limit }, this.getStatus);
  }

  getResults = (results) => {
    const { status, action, issue } = this.state;
    return _.map(results, r => {
      let hidden = false;
      if (status === 'HEALTHY' && r.errors && r.errors.length) hidden = true;
      if (status === 'SICK' && (!r.errors || !r.errors.length)) hidden = true;

      const actions = {};
      if (r.errors) {
        if (r.errors.indexOf('PULL JOB NOT REQUIRED') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('NO WEBHOOK') > -1)  actions.RESYNC = true;
        if (r.errors.indexOf('JOB NOT MAPPED') > -1) actions.REMAP = true;
        if (r.errors.indexOf('JOB NOT FOUND') > -1) actions.CREATE = true;
        if (r.errors.indexOf('META NOT FOUND') > -1) actions.REMAP = true;
        if (r.errors.indexOf('JOB IS FAILED') > -1) actions.RETRY = true;
        if (r.errors.indexOf('JOB IS COMPLETED') > -1) actions.RETRY = true;
        if (r.errors.indexOf('JOB IS STUCK') > -1) actions.RETRY = true;
        if (r.errors.indexOf('MULTIPLE WEEKLY JOBS') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('MULTIPLE PULL JOBS') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('MULTIPLE AUDIT JOBS') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('PULL USER IS WRONG') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('WEEKLY USER IS WRONG') > -1) actions.CLEAN = true;
        if (r.errors.indexOf('WEBHOOK IS NOT REQUIRED') > -1) actions.WEBHOOK = true;
      }
      if (r.normal.length && _.some(r.normal, (j) => { return !this.isMapped(r, j) })) {
        actions.REMAP = true; actions.CLEAN = true;
      }
      if (r.audit.length && _.some(r.audit, (j) => { return !this.isMapped(r, j) })) {
        actions.REMAP = true; actions.CLEAN = true;
      }
      if (r.pulling.length && _.some(r.pulling, (j) => { return !this.isMapped(r, j) })) {
        actions.REMAP = true; actions.CLEAN = true;
      }
      if (r.errors.indexOf('NO ACCESS') || r.errors.indexOf('NO BOARD') || r.errors.indexOf('NO USER')) {
        delete actions.CREATE;
        delete actions.RETRY;
        actions.CLEAN = true;
      }
      if (action === 'CLEAN' && !actions.CLEAN) hidden = true;
      if (action === 'RESYNC' && !actions.RESYNC) hidden = true;
      if (action === 'CREATE' && !actions.CREATE) hidden = true;
      if (action === 'REMAP' && !actions.REMAP) hidden = true;
      if (action === 'RETRY' && !actions.RETRY) hidden = true;
      if (action === 'WEBHOOK' && !actions.WEBHOOK) hidden = true;

      if (issue !== 'ALL') {
        if (!r.errors || r.errors.indexOf(issue) === -1) hidden = true;
      }

      return {
        ...r,
        hidden
      }
    });
  }

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, this.state.limit, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }
    return (
      <Pagination>
        {pages.currentPage > 1 && <Pagination.First onClick={() => this.goto(1)} />}
        {pages.currentPage > 1 && <Pagination.Prev onClick={() => this.goto(pages.currentPage - 1)} />}
        {pages.pages.map((p, i) => {
          return (
            <Pagination.Item key={i} active={p === pages.currentPage} onClick={() => this.goto(p)}>
              {p}
            </Pagination.Item>
          );
        })}
        {pages.currentPage < pages.totalPages && <Pagination.Next onClick={() => this.goto(pages.currentPage + 1)} />}
        {pages.currentPage < pages.totalPages && <Pagination.Last onClick={() => this.goto(pages.totalPages)} />}
      </Pagination>
    );
  };

  printStats = (stats) => {
    return stats ? 
      `W: ${stats.waiting} | A: ${stats.active} | F: ${stats.failed} | C: ${stats.completed} | D: ${stats.delayed}` :
      '';
  }

  renderStatus = () => {
    const { results, isLoading } = this.props;
    const rows = this.getResults(results);
    // const data = rows && rows[0];
    return (
      <div className='table'  >
        <table>
          {/*<thead>
            <tr>
              <th>
                
              </th>
              <th>Dashboard Name</th>
              <th>Dashboard ID</th>
              <th>Status</th>
              <th>Owner</th>
              <th>Created by</th>
              <th>Updated by</th>*/}
              {/*data && data.boardJQL && <th>Dashboard JQL</th>*/}
              {/*<th>Dashboard JQL</th>
              <th>Webhook</th>*/}
              {/*data && data.errors && !!data.errors.length && <th>Issues</th>*/}
              {/*<th>Issues</th>
              <th></th>
            </tr>
          </thead>*/}
          <tbody>
            { !isLoading && rows && _.map(rows, (data, i) => !data.hidden && this.renderRow(data, i))}
           </tbody>
        </table>
      </div>
    )
  }

  getStatusMessage = (job) => {
    switch (job.state) {
      case 'active': return 'Job is running';
      case 'waiting': return 'Job is waiting to run';
      case 'delayed': return <Fragment><span className='status-title'>Next run:</span> {moment(job.timestamp + job.delay).format(this.state.dateFormat)}</Fragment>;
      case 'failed': return <Fragment><span className='status-title'>Fail reason:</span> {job.failedReason}</Fragment>;
      case 'completed': return 'Job is completed';
      default: return '';
    }
  }

  isMapped = (data, job) => {
    return (job.type === 'normal' && data.normalJobs[0] && job.id === data.normalJobs[0].bullJobId) ||
      (job.type === 'audit' && data.auditJobs[0] && job.id === data.auditJobs[0].bullJobId) ||
      (job.type === 'pulling' && data.pullingJobs[0] && job.id === data.pullingJobs[0].bullJobId);
  }

  isRequired = (data, job) => {
    return (
      (job.type === 'pulling') &&
      (data.app === 'jira' || data.app === 'azure') &&
      (data.subscription === 'active' || data.subscription === 'trial') &&
      !data.webhookId
    ) || (job.type === 'normal' && data.app !== 'jira') || (job.type === 'audit' && data.app === 'jira' && (data.subscription === 'active' || data.subscription === 'trial'));
  }

  hasFailed = (data, type) => {
    return _.some(data[type], (j) => j.state === 'failed' && !this.isMapped(data, j));
  }

  hasCompleted = (data, type) => {
    return _.some(data[type], (j) => j.state === 'completed' && !this.isMapped(data, j));
  }

  selectDashboard = ({name, checked}) => {
    if (name) {
      this.setState({
        selected: {
          ...this.state.selected,
          [name]: checked
        }
      });
    }
  }

  selectAllDashboards = ({checked}) => {
    const data = this.getResults(this.props.results);
    console.log('!data', data);
    console.log('!apply filters', _.filter(data, d => !d.hidden));

    const selected = {};
    _.forEach(data, d => {
      selected[d.dashboardId] = !d.hidden && checked;
    });
    console.log('!setSelected', selected);
    console.log('!state.selected', this.state.selected);
    this.setState({ selected });
  }

  isAllDashboardsSelected = () => {
    const { selected } = this.state;
    const data = this.getResults(this.props.results);
    return !_.some(data, d => !selected[d.dashboardId] && !d.hidden);
  }

  renderActions = (data, job) => {
    const actions = {};
    const noAccess = job.failedReason && job.failedReason.indexOf('getAccountAndUser error') === 0;
    const wrongUser = data.updatedBy ? (data.updatedBy !== job.data.userId) : (data.createdBy !== job.data.userId);
    if (this.isRequired(data, job)) {
      const hasActive = _.some(data[job.type], j => j.state === 'active' || j.state === 'waiting');
      const onlyJob = data[job.type].length <= 1 && data[`${job.type}Jobs`].length <= 1;
      const isMapped = this.isMapped(data, job);
      const isAwaitLock = job.data.isAwaitLock;
      if (!isMapped && job.state !== 'waiting' && job.state !== 'active') {
        if (job.state !== 'completed' && !isAwaitLock) actions.REMAP = true;
        if (!onlyJob) actions.CLEAN = true;
      }
      if (wrongUser) {
        actions.CLEAN = true;
      }
      switch(job.state) {
        case 'delayed':
          if (!hasActive) {
            actions.PROMOTE = true;
          }
          break;
        case 'failed':
          if (!hasActive) {
            actions.RETRY = true;
          }
          break;
        case 'completed': actions.CLEAN = true; break;
        default: break;
      }
    } else if (job.state !== 'waiting' && job.state !== 'active') {
      actions.CLEAN = true;
    }
    if (noAccess) {
      actions.CLEAN = true;
    }
    return _(actions)
      .keys()
      .map((k, i) => {
        return this.renderActionButton(`${k} ${ job.type === 'normal' ? 'WEEKLY' : job.type === 'audit' ? 'AUDIT' : 'PULL' } JOB`, job.id, i);
      })
      .value();
  }

  renderRow = (data, i) => {
    const { selected } = this.state;
    // const noAccess = data.errors && data.errors.indexOf('NO ACCESS') > -1;
    // const noBoard = data.errors && data.errors.indexOf('NO BOARD') > -1;
    // const noUser = data.errors && data.errors.indexOf('NO USER') > -1;
    return (
      <tr key={i}>
        <td style={{width: "60px"}}>
          <Form.Group controlId="bulkSelect">
            <CheckBox
              name={data.dashboardId}
              id={data.dashboardId}
              checked={!!selected[data.dashboardId]}
              onChange={this.selectDashboard}
            />
          </Form.Group>
        </td>
        <td>
          <p><label>Dashboard Name:</label> {data.name}</p>
          <p><label>Dashboard ID:</label> {data.dashboardId}</p>
          <p><label>Status:</label> <span className={`label-status ${data.errors && data.errors.length ? 'sick' : 'healthy'}`}>{data.errors && data.errors.length ? 'sick' : 'healthy'}</span></p>
          <p><label>Owner:</label> {data.ownerId} <span className='badge-state'>{_.upperFirst(data.subscription)}</span></p>
          <p><label>Created by: </label> {data.createdBy} <span>{moment(data.createdAt).format(this.state.dateFormat)}</span></p>
          <p><label>Updated by:</label> {data.updatedBy} <span>{moment(data.updatedAt).format(this.state.dateFormat)}</span></p>
          <React.Fragment>{data.boardJQL && <p><label>Dashboard JQL:</label> {data.boardJQL}</p>}</React.Fragment>
        </td>
  
        <td>
          { data.webhook &&
            (
              <Fragment>
                <p><label>External Webhook ID:</label><span>{data.webhook.externalId}</span></p>
                <p><label>Webhook owner:</label><span>{data.userEmail}</span></p>
                <p><label>Host URL:</label><span>{data.userHost}</span></p>
              </Fragment>
            )
          }
          { 
            (!data.webhook && (data.webhookId || data.lastWebhookReceived)) && 
            <p>{moment(data.lastWebhookReceived).format(this.state.dateFormat)}</p>
          }
          { 
            (!data.webhook && !data.webhookId && !data.lastWebhookReceived) && 
            <p className='auto-phrase'>No webhook</p>
          }
        </td>
        
        { data.webhook &&
          <td>
            <p><label>Webhook JQL:</label><span>{data.webhook.jql}</span></p>
            <p><label>Webhook URL:</label><EllipsisWithTooltip url={data.webhook.url} /></p>
            <p><label>Webhook created at:</label><span>{moment(data.webhook.createdAt).format(this.state.dateFormat)}</span></p>
            <p><label>Last webhook update received at:</label><span>{moment(data.webhook.lastCalledAt).format(this.state.dateFormat)}</span></p>
            <p><label>Webhook prolonged At:</label><span>{moment(data.webhook.lastProlongedDate).format(this.state.dateFormat)}</span></p>              
          </td>
        }
        
        <td>
          {data && data.errors && !!data.errors.length &&
            <p className='auto-phrase'>{data.errors.join(' | ')}</p>
          }
        </td>
        <td style={{width: "64px"}}>
          <Button variant='secondary' className='btn-icon' size='md' onClick={() => this.setState({ moreInfoModal: { show: true, data } })}>
            <img src={openInNewIcon} alt="more info" />
          </Button>
        </td>
      </tr>
    );
  };

  renderMoreInfoModal = () => {
    const { moreInfoModal } = this.state;
    const data = moreInfoModal.data;
    if (!data) return null;
    const noAccess = data.errors && data.errors.indexOf('NO ACCESS') > -1;
    const noBoard = data.errors && data.errors.indexOf('NO BOARD') > -1;
    const noUser = data.errors && data.errors.indexOf('NO USER') > -1;
    return (
      <Modal
        show={moreInfoModal.show}
        onHide={() => this.setState({ moreInfoModal: { show: false, data: null } })}
        size="lg" className='status-modal'
      >
        <Modal.Header>
          <Modal.Title>Weekly jobs</Modal.Title>
          <Button variant="close" onClick={() => this.setState({ moreInfoModal: { show: false, data: null } })}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className='status-modal__header'>
            <p>{data.name}</p>
            <span className={`label-status ${data.errors && data.errors.length ? 'sick' : 'healthy'}`}>{data.errors && data.errors.length ? 'sick' : 'healthy'}</span>
          </div>
          {
            _.map([...data.normal, ...data.pulling, ...data.audit], (n, i) => {
              return (
                <div key={i} className={`status-modal__box ${(n.state === 'failed') ? 'red' : 'green'}`}>
                    <h3>
                      <img className='icon' src={(n.state === 'failed') ? failedIcon : delayIcon} alt="icon" />
                      {n.type === 'normal' ? 'Weekly' : n.type === 'audit' ? 'Audit' : 'Pull Job'}{' '}
                      {n.state}{' '}
                      {this.isMapped(data, n) ? 'mapped' : 'not mapped'}
                    </h3>

                    <div className='status-item'>
                      {(() => {
                        const [type, hash, timestamp] = n.id.split(':');
                        const date = timestamp && new Date(Number(timestamp)).toLocaleString();
                        return <>
                          <span className="status-title">{type}:</span>
                          { hash && <span>{hash}</span> }
                          { date && <span>{date}</span> }
                        </>
                      })()}
                    </div>
                    <div className='status-item'><span className="status-title">User:</span> {n.data.userId}</div>
                    <div className='status-item'>{this.getStatusMessage(n)}</div>
                    {this.isMapped(data, n) && <div className='status-item'><span className="status-title">Progress:</span> {data[`${n.type}Jobs`][0]?.progress}</div>}
                    {this.isMapped(data, n) && <div className='status-item'><span className="status-title">Error:</span> {data[`${n.type}Jobs`][0]?.error}</div>}

                    <div className='status-modal__btn-actions'>{this.renderActions(data, n)}</div>
                </div>
              );
            })
          }
        </Modal.Body>
        <Modal.Footer>
          <Fragment>
            {
              _.map(data.errors ? ['', ...data.errors] : [''], (e, i) => {
                return (
                  <Fragment key={i}>
                    {e === 'NO USER' && (!!data.pulling.length || !!data.normal.length) && this.renderActionButton('REMOVE JOBS', data)}
                    {e === 'NO ACCESS' && !noUser && (!!data.pulling.length || !!data.normal.length) && this.renderActionButton('REMOVE JOBS', data)}
                    {e === 'NO BOARD' && !noUser && !noAccess && (!!data.pulling.length || !!data.normal.length) && this.renderActionButton('REMOVE JOBS', data)}
                    {e === 'WEEKLY JOB NOT FOUND' && !noAccess && !noBoard && !noUser && this.renderActionButton('CREATE WEEKLY JOB', data.dashboardId)}
                    {e === 'WEEKLY JOB NOT FOUND' && (noAccess || noBoard || noUser) && (!!data.normalJobs.length) && this.renderActionButton('CLEAN WEEKLY META', data.dashboardId)}
                    {e === 'PULL JOB NOT FOUND' && !noAccess && !noBoard && !noUser && this.renderActionButton('CREATE PULL JOB', data.dashboardId)}
                    {e === 'PULL JOB NOT FOUND' && (noAccess || noBoard || noUser) && (!!data.pullingJobs.length) && this.renderActionButton('CLEAN PULL META', data.dashboardId)}
                    {e === 'AUDIT JOB NOT FOUND' && !noAccess && !noBoard && !noUser && this.renderActionButton('CREATE AUDIT JOB', data.dashboardId)}
                    {e === 'AUDIT JOB NOT FOUND' && (noAccess || noBoard || noUser) && (!!data.auditJobs.length) && this.renderActionButton('CLEAN AUDIT META', data.dashboardId)}
                    {e === 'PULL JOB NOT REQUIRED' && !!data.pullingJobs[0] && this.renderActionButton('CLEAN PULL META', data.dashboardId)}
                    {e === 'WEBHOOK IS NOT REQUIRED' && this.renderActionButton('CLEAN WEBHOOK', data.dashboardId)}
                    {e === '' && (
                      this.hasFailed(data, 'audit') ||
                      this.hasFailed(data, 'pulling') ||
                      this.hasFailed(data, 'normal') ||
                      this.hasCompleted(data, 'audit') ||
                      this.hasCompleted(data, 'pulling') ||
                      this.hasCompleted(data, 'normal')
                    ) && this.renderActionButton('CLEAN-UP JOBS', data)}
                  </Fragment>
                );
              })
            }
          </Fragment>
          <Button variant="secondary" onClick={() => this.setState({ moreInfoModal: { show: false, data: null } })}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  renderActionButton = (action, id, i = 0) => {
    let text = (<p></p>);
    let confirm = '';
    let variant = 'secondary';
    let size = '';
    let cb;
    switch (action) {
      case 'PROMOTE PULL JOB': 
        text = (<p>Are you sure you want to promote job?</p>);
        confirm = 'Promote';
        cb = () => this.promote(id, true);
        size='md';
        break;
      case 'PROMOTE AUDIT JOB': 
        text = (<p>Are you sure you want to promote job?</p>);
        confirm = 'Promote';
        cb = () => this.promote(id, false, true);
        size='md';
        break;
      case 'PROMOTE WEEKLY JOB': 
        text = (<p>Are you sure you want to promote job?</p>);
        confirm = 'Promote';
        cb = () => this.promote(id);
        size='md';
        break;
      case 'RETRY AUDIT JOB':
        text = (<p>Are you sure you want to retry job?</p>);
        confirm = 'Retry';
        cb = () => this.retry(id, false, true);
        size='md';
        break;
      case 'RETRY PULL JOB':
        text = (<p>Are you sure you want to retry job?</p>);
        confirm = 'Retry';
        cb = () => this.retry(id, true);
        size='md';
        break;
      case 'RETRY WEEKLY JOB':
        text = (<p>Are you sure you want to retry job?</p>);
        confirm = 'Retry';
        cb = () => this.retry(id);
        size='md';
        break;
      case 'CREATE WEEKLY JOB':
        text = (<p>Are you sure you want to create job?</p>);
        confirm = 'Create weekly job';
        cb = () => this.create(id, false);
        size='md';
        break;
      case 'CREATE PULL JOB':
        text = (<p>Are you sure you want to create job?</p>);
        confirm = 'Create pull job';
        cb = () => this.create(id, true);
        size='md';
        break;
      case 'CREATE AUDIT JOB':
        text = (<p>Are you sure you want to create job?</p>);
        confirm = 'Create audit job';
        cb = () => this.create(id, false, true);
        size='md';
        break;
      case 'CLEAN WEEKLY JOB':
        text = (<p>Are you sure you want to clean job?</p>);
        confirm = 'Clean weekly job';
        cb = () => this.clean(id, false);
        size='md';
        break;
      case 'CLEAN WEEKLY META':
        text = (<p>Are you sure you want to remove meta?</p>);
        confirm = 'Clean weekly meta';
        cb = () => this.cleanMeta(id, false);
        variant='primary';
        break;
      case 'CLEAN PULL META':
        text = (<p>Are you sure you want to remove meta?</p>);
        confirm = 'Clean pull meta';
        cb = () => this.cleanMeta(id, true);
        variant='primary';
        break;
      case 'CLEAN AUDIT META':
        text = (<p>Are you sure you want to remove meta?</p>);
        confirm = 'Clean audit meta';
        cb = () => this.cleanMeta(id, false, true);
        variant='primary';
        break;
      case 'CLEAN AUDIT JOB':
        text = (<p>Are you sure you want to clean job?</p>);
        confirm = 'Clean audit job';
        cb = () => this.clean(id, false, true);
        size='md';
        break;
      case 'CLEAN PULL JOB':
        text = (<p>Are you sure you want to clean job?</p>);
        confirm = 'Clean pull job';
        cb = () => this.clean(id, true);
        size='md';
        break;
      case 'REMAP WEEKLY JOB':
        text = (<p>Are you sure you want to remap job?</p>);
        confirm = 'Remap weekly job';
        cb = () => this.remap(id, false);
        size='md';
        break;
      case 'REMAP PULL JOB':
        text = (<p>Are you sure you want to remap job?</p>);
        confirm = 'Remap pull job';
        cb = () => this.remap(id, true);
        size='md';
        break;
      case 'REMAP AUDIT JOB':
        text = (<p>Are you sure you want to remap job?</p>);
        confirm = 'Remap audit job';
        cb = () => this.remap(id, false, true);
        size='md';
        break;
      case 'CLEAN-UP JOBS':
        text = (<p>Are you sure you want to clean-up jobs?</p>);
        confirm = 'Clean-up jobs';
        cb = () => this.cleanUp(id);
        variant='primary';
        break;
      case 'CLEAN WEBHOOK':
        text = (<p>Are you sure you want to remove webhook?</p>);
        confirm = 'Clean Webhook';
        cb = () => this.cleanWebhook(id);
        variant='primary';
        break;
      case 'REMOVE JOBS':
        text = (<p>Are you sure you want to remove all jobs?</p>);
        confirm = 'Remove Jobs';
        cb = () => this.remove(id);
        variant='primary';
        break;
      default: return null;
    }
    return (
      <Confirm
        key={i}
        body={text}
        confirmText={confirm}
        icon={resyncIcon}
        title={confirm}
        onConfirm={cb}
      >
        <Button variant={variant} size={size}>
          { confirm }
        </Button>
      </Confirm>
    );
  }

  addTo = (key) => {
    const { selected } = this.state;
    const to = this.state[key];
    const { results } = this.props;
    const toAdd = [];
    _.forEach(selected, (v, k) => {
      if (v) {
        toAdd.push(_.find(results, r => r.dashboardId === k));
      }
    });
    this.setState({
      [key]: _(toAdd).compact().concat(to).uniqBy('dashboardId').value()
    });
  }

  renderStats = () => {
    const { stats, isLoading } = this.props;
    
    const result = [];
    if (!isLoading && stats) {
      result.push((
        <div key={1} className='queue-stats'>
          <div className='queue-stats-title'>Weekly</div>
          <div className='queue-stats-label waiting'>{`${stats.weekly.waiting} waiting`}</div>
          <div className='queue-stats-label active'>{`${stats.weekly.active} active`}</div>
          <div className='queue-stats-label completed'>{`${stats.weekly.completed} completed`}</div>
          <div className='queue-stats-label failed'>{`${stats.weekly.failed} failed`}</div>
          <div className='queue-stats-label delayed'>{`${stats.weekly.delayed} delayed`}</div>
        </div>
      ));
      if (stats.pull) {
        result.push((
          <div key={2} className='queue-stats'>
            <div className='queue-stats-title'>Pull</div>
            <div className='queue-stats-label waiting'>{`${stats.pull.waiting} waiting`}</div>
            <div className='queue-stats-label active'>{`${stats.pull.active} active`}</div>
            <div className='queue-stats-label completed'>{`${stats.pull.completed} completed`}</div>
            <div className='queue-stats-label failed'>{`${stats.pull.failed} failed`}</div>
            <div className='queue-stats-label delayed'>{`${stats.pull.delayed} delayed`}</div>
          </div>
        ));
      }
      if (stats.audit) {
        result.push((
          <div key={3} className='queue-stats'>
            <div className='queue-stats-title'>Audit</div>
            <div className='queue-stats-label waiting'>{`${stats.audit.waiting} waiting`}</div>
            <div className='queue-stats-label active'>{`${stats.audit.active} active`}</div>
            <div className='queue-stats-label completed'>{`${stats.audit.completed} completed`}</div>
            <div className='queue-stats-label failed'>{`${stats.audit.failed} failed`}</div>
            <div className='queue-stats-label delayed'>{`${stats.audit.delayed} delayed`}</div>
          </div>
        ));
      }
    }

    return result;
  }

  renderControls = () => {
    const { toCleanUp, toCleanMeta, toCreatePull, toRemove } = this.state;
    return (
      <Fragment>
        <div className='action-set'>
          <Button variant='width-secondary' size='md'  onClick={() => this.addTo('toCleanUp')} >
            <span className='number-box'>{toCleanUp.length}</span> Clean up
          </Button>
          <Confirm
            body="Do you want to clean up dashboards?"
            confirmText="Clean up"
            icon={resyncIcon}
            title="Clean up"
            onConfirm={this.cleanDashboardsUp}
          >
            <span className={`button-run ${toCleanUp.length ? 'enabled' : 'disabled'}`}><img src={arrowRight} alt=""/></span>
          </Confirm>
        </div>

        <div className='action-set'>
          <Button variant='width-secondary' size='md' onClick={() => this.addTo('toCleanMeta')}>
            <span className='number-box'>{toCleanMeta.length}</span> Clean Meta 
          </Button>
          <Confirm
            body="Do you want to clean jobs meta?"
            confirmText="Clean"
            icon={resyncIcon}
            title="Clean"
            onConfirm={this.cleanDashboardsMeta}
          >
            <span className={`button-run ${toCleanMeta.length ? 'enabled' : 'disabled'}`}><img src={arrowRight} alt=""/></span>
          </Confirm>
        </div>

        <div className='action-set'>
          <Button variant='width-secondary' size='md' onClick={() => this.addTo('toCreatePull')}>
            <span className='number-box'>{toCreatePull.length}</span> Create Pull
          </Button>
          <Confirm
            body="Do you want to create pull jobs?"
            confirmText="Create"
            icon={resyncIcon}
            title="Create"
            onConfirm={this.createDashboardsPull}
          >
            <span className={`button-run ${toCreatePull.length ? 'enabled' : 'disabled'}`}><img src={arrowRight} alt=""/></span>
          </Confirm>
        </div>

        <div className='action-set'>
          <Button variant='width-secondary' size='md' onClick={() => this.addTo('toRemove')}>
            <span className='number-box'>{toRemove.length}</span> Remove Jobs
          </Button>
          <Confirm
            body="Do you want to remove jobs?"
            confirmText="Remove"
            icon={resyncIcon}
            title="Remove"
            onConfirm={this.removeDashboardsJobs}
          >
            <span className={`button-run ${toRemove.length ? 'enabled' : 'disabled'}`}><img src={arrowRight} alt=""/></span>
          </Confirm>
        </div>
      </Fragment>
    );
  }

  render() {
    const { isLoading, total } = this.props;

    return (
      <div className='maintenance-content'>
        <div className='jobs-stats' id="jobs-stats">
          { this.renderStats() }
        </div>
  
        <div className='table-content table-maintenance status'>
          <div className='table-filter'>
            
            <div className='table-filter-group'>
              <h2>Maintenance</h2>
              <div className='jobs-controls' id="jobs-controls">
                { this.renderControls() }
              </div>

              <Form.Group controlId="Search" className="search-form">
                <Form.Control
                  type="text"
                  name="search"
                  placeholder="Search"
                  onChange={this.handleChange}
                  value={this.state.searchInput}
                />
              </Form.Group>
            </div>
            
            <div className='table-filter-group'>
              <Form.Group
                controlId="bulkSelect"
                className='bulk-select d-flex align-items-center justify-content-center pr-2'>
                <CheckBox
                  name="isAllChecked"
                  id="isAllChecked"
                  checked={this.isAllDashboardsSelected()}
                  onChange={this.selectAllDashboards}
                />
              </Form.Group>

              <Form.Group controlId="app" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('app')}
                >
                  {this.state.appOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.app === f.value ? 'active' : ''}
                        onClick={() => this.applyAppFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="subs" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('subs')}
                >
                  {this.state.subsOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.subs === f.value ? 'active' : ''}
                        onClick={() => this.applySubsFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="webhook" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('webhook')}
                >
                  {this.state.webhookOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.webhook === f.value ? 'active' : ''}
                        onClick={() => this.applyWebhookFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="weekly" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('weeklyJob')}
                >
                  {this.state.weeklyJobOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.weeklyJob === f.value ? 'active' : ''}
                        onClick={() => this.applyWeeklyFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="pulljob" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('pullJob')}
                >
                  {this.state.pullJobOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.pullJob === f.value ? 'active' : ''}
                        onClick={() => this.applyPullFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="auditjob" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('auditJob')}
                >
                  {this.state.auditJobOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.auditJob === f.value ? 'active' : ''}
                        onClick={() => this.applyAuditFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="status" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('status')}
                >
                  {this.state.statusOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.status === f.value ? 'active' : ''}
                        onClick={() => this.applyStatusFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="action" className="filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('action')}
                >
                  {this.state.actionOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.action === f.value ? 'active' : ''}
                        onClick={() => this.applyActionFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="issue" className="filter-dropdown filter-dropdown-wide">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('issue')}
                >
                  {this.state.issueOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.issue === f.value ? 'active' : ''}
                        onClick={() => this.applyIssueFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>

              <Form.Group controlId="action" className="white filter-dropdown">
                <DropdownButton
                  className="form-dropdown"
                  id="dropdown-item-button"
                  title={this.renderSelected('limit')}
                >
                  {this.state.limitOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.limit === f.value ? 'active' : ''}
                        onClick={() => this.applyLimitFilter(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>
            </div>
          </div>

          {isLoading && (
            <div className='table-loading'>
              <Loading />
            </div>
          )}
          {!isLoading && total === 0 && (
            <div className='no_data'>
              <p> No data available </p>
            </div>
          )}

          { this.renderStatus() }
        </div>
        { total > 0 && this.renderPagination() }
        { this.renderMoreInfoModal() }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getStatus: (opt) => dispatch(getStatus(opt)),
    promoteJobs: (ids, opt) => dispatch(promoteJobs(ids, opt)),
    retryJobs: (ids, opt) => dispatch(retryJobs(ids, opt)),
    createJobs: (ids, opt) => dispatch(createJobs(ids, opt)),
    cleanJobs: (ids, opt) => dispatch(cleanJobs(ids, opt)),
    remapJobs: (ids, opt) => dispatch(remapJobs(ids, opt)),
    removeJobs: (ids, opt) => dispatch(removeJobs(ids, opt)),
    cleanMeta: (ids, opt) => dispatch(cleanMeta(ids, opt)),
    cleanUp: (ids, opt) => dispatch(cleanUp(ids, opt)),
    cleanWebhook: (ids, opt) => dispatch(cleanWebhook(ids, opt)),
  };
};

function mapStateToProps(state) {
  return {
    results: state.status.results,
    stats: state.status.stats,
    isLoading: state.status.isLoading,
    page: state.status.page,
    total: state.status.total,
    user: state.auth.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatusTable);
